<template>
    <div class="container">
        <div class="main">
            <div class="title" style="text-align:center;font-size: 20px;font-weight: bold"> Team DIXCEL邀请您参与超吉联赛PRO! </div>
            <div style="color :gray;font-size :14px;text-align:center;margin-bottom:20px">2023-04-19</div>
            <div style="line-height:30px">
                <div style="text-align:center;font-size: 20px;font-weight: bold">

                    <el-image  style="width:80%;margin-bottom:20px"
                               :src="require('@/assets/image/moment/newsActivitiesPage/2023_04_19/15.png')"
                               fit="fit">
                    </el-image>
                </div>
                <div style="text-indent:30px;font-size: 14px;">超吉联赛PRO是由吉利控股集团汽车运动部发起并主办的国内中高阶房车统规赛事（200-250匹，序列式）
                    。该项赛事填补国内目前入门级房车赛事（150-250匹，手动/自动）与职业房车赛事（300匹以上，序列式）之间的空白地带，
                    是目前国内唯一采用序列式换挡机构的统一规格房车赛事。赛事定位于国内目前所有H档统规赛之上，与CTCC/CEC部分中级组别相当。</div>
                <div style="text-indent:30px;font-size: 14px;">参与超吉联赛PRO的车手必须持有国家B级场地类赛车驾照，同时对赛车驾驶或车手生涯有更高的要求和期望，赛事为怀揣此类目标的的车手提供了更富价值的向上通道。</div>
                <div style="text-indent:30px;font-size: 14px;">超吉联赛PRO目前设有5支“创始人车队”，每车队2个车组，每车组可支持1-3人参赛，报名形式为全年或单站，
                    车队可根据招募情况，进行席位的分配调整。创始人车队的车手不仅可参与分站领奖台和奖金的争夺，还可参与车组和车队的年度积分奖励争夺。
                    同时享有官方组织的季前测试权益，且每站可获得免费的车载数据开放。此外，创始人车队也将提供更多的定制化服务、针对性指导及其它激励政策，具体以车队信息公布为准。</div>
                <div style="text-indent:30px;font-size: 14px;">如未能从创始人车队获得席位，或期望更简单的“拎包参赛”的比赛方式，可选择“独立车手”的形式在线报名。
                    独立车手席位开放6车组/站，同样支持1-3人参赛，报名人购得席位后可自行组队，但仅支持分站报名，具体报名时间和费用以每站官方公布为准。
                    独立车手可享受赛会标准服务参与分站奖金的争夺，可根据需求购买车载数据等。</div>

                <div style="text-align: center">
                    <el-image  style="width:10%;margin-bottom:20px"
                               :src="require('@/assets/image/moment/newsActivitiesPage/2023_04_19/1.png')"
                               fit="fit">
                    </el-image>
                </div>
                <div style="text-align:center;font-weight: bold">感受DIXCEL的速度与激情</div>
                <div style="text-align:center;color: rgb(223, 0, 36);font-weight: bold;margin-bottom:20px">Fight together，Enjoy together！</div>
                <div style="text-align:center;"><span style="background: rgb(223, 0, 36);color: #fff;font-size: 36px;">Team DIXCEL</span></div>

                <div style="margin-bottom:20px">作为5支创始人车队之一，Team DIXCEL现对外招收车手，车队配置和福利如下:</div>
                <div style="color: rgb(136, 136, 136);font-size: 18px;margin-bottom:20px">人员配置</div>
                <div style="margin-bottom:20px;text-align: center">
                    <el-image  style="width:100%;"
                               :src="require('@/assets/image/moment/newsActivitiesPage/2023_04_19/2.jpg')"
                               fit="fit">
                    </el-image>
                </div>
                <div style="margin-bottom:20px;font-size: 16px;">车队经理：常亮——身经百战铸就的实力与荣耀</div>
                <div style="margin-bottom:20px;font-size: 14px;">本次Team DIXCEL的车队经理由DIXCEL中国总经理常亮先生担任。从2011年起，
                    当时还在日本DIXCEL任职的常亮先生跟随前DIXCEL日本社长井田雅彦先生征战国内外各类赛事。吉利超吉联赛、CTCC中国房车锦标赛、
                    大众尚酷R杯、大众POLO杯、CHINAGT、CEC、Formula Master、亚洲F3、亚洲宝珀GT、日本SuperGT、日本SuperTaikyu
                    、D1日本/中国等国内外赛场均能看见他的身影。</div>

                <div style=";text-align: center" >
                    <el-image  style="width:100%;"
                               :src="require('@/assets/image/moment/newsActivitiesPage/2023_04_19/3.jpg')"
                               fit="fit">
                    </el-image>
                </div>

                <div style="margin-bottom:20px;font-size: 16px;">车队顾问：井田雅彦——从职业赛车手到品牌创始人的华丽转身</div>
                <div style="margin-bottom:20px;font-size: 14px;">车队顾问由DJHOLDINGS社长井田雅彦先生担任（DIXCEL日本/中国均为DJHOLDINGS子公司）。
                    在成立DIXCEL品牌之前，井田雅彦先生是一位职业赛车手，曾数次获得日本SuperTaikyu年度冠军。转型成为品牌创始人之后的他依然活跃
                    在国内外各类赛事中，并取得过不俗战绩。热爱中国文化的他，一直积极致力于推动中日友好关系的发展，与每一位中国车手切磋技艺并交流
                    心得从而加深中日两国民间的友谊是他最大的梦想。值得一提的是，井田雅彦先生将作为Team DIXCEL的车手之一，参与今年的超吉联赛。</div>

                <div style=";text-align: center">
                    <el-image  style="width:100%;"
                               :src="require('@/assets/image/moment/newsActivitiesPage/2023_04_19/4.jpg')"
                               fit="fit">
                    </el-image>
                </div>
                <div style="margin-bottom:20px;font-size: 14px;">执行经理2名：负责车队日常事务并与车手对接。</div>

                <div style=";text-align: center">
                    <el-image  style="width:100%;"
                               :src="require('@/assets/image/moment/newsActivitiesPage/2023_04_19/5.jpg')"
                               fit="fit">
                    </el-image>
                </div>
                <div style="margin-bottom:20px;font-size: 14px;">车队技师2名：负责车队赛事期间的车辆维护。</div>

                <div style=";text-align: center" >
                    <el-image  style="width:100%;"
                               :src="require('@/assets/image/moment/newsActivitiesPage/2023_04_19/6.jpg')"
                               fit="fit">
                    </el-image>
                </div>
                <div style="margin-bottom:20px;font-size: 14px;">赛车模特2名：以全新形象登场的2023年度DIXCEL GIRLS必将惊艳全场。</div>
                <div style="font-size: 18px;font-weight: bold;color: rgb(136, 136, 136)">Team Slogan</div>
                <div style="font-size: 16px;color: rgb(223, 0, 36);font-weight: bold; ">Fight together，Enjoy together！</div>
                <div style=";text-align: center">
                    <el-image  style="width:100%;margin-bottom:20px"
                               :src="require('@/assets/image/moment/newsActivitiesPage/2023_04_19/7.jpg')"
                               fit="fit">
                    </el-image>
                </div>
                <div style="font-weight: bold;color: rgb(136, 136, 136)">车队特色</div>
                <div style="margin-bottom:20px">
                    <ui style="list-style-type: square;margin-left: 0px;margin-right: 0px;font-size: 14px;">
                        <li>唯一日本全资车队</li>
                        <li>唯一拥有外籍车手（日籍）的车队</li>
                        <li>能感受到日本文化的车队</li>
                        <li>中文/日文/英文可（国际氛围）</li>
                    </ui>
                </div>


                <div style="font-weight: bold;color: rgb(136, 136, 136)">特典（专属福利）</div>
                <div style="font-size: 14px;font-weight: bold;">DIXCEL中国经销商特典：</div>

                <div style="margin-bottom:20px">
                    <ui style="list-style-type: square;margin-left: 0px;margin-right: 0px;font-size: 14px;">
                        <li>DIXCEL ONLINE经销商采购平台优惠券1万元</li>
                        <li>运费优待政策</li>
                        <li>特别版经销商授权证书</li>
                        <li>DIXCEL中国官方社交平台（官网/微信公众号/微博/抖音/视频号等）宣传</li>
                    </ui>
                </div>

                <div style="font-size: 14px;font-weight: bold;">非DIXCEL中国经销商特典：</div>
                <div style="margin-bottom:20px">
                    <ui style="list-style-type: square;margin-left: 0px;margin-right: 0px;font-size: 14px;">
                        <li>全车套DIXCEL产品（前后刹车片/前后刹车碟/刹车油）礼品包</li>
                        <li>购买其他DIXCEL产品的优惠</li>

                    </ui>
                </div>



                <div style="font-size: 14px;font-weight: bold;">共通特典：</div>
                <div>
                    <ui style="list-style-type: square;margin-left: 0px;margin-right: 0px;font-size: 14px;">
                        <li>DJHOLDINGS社长井田雅彦先生亲自指导</li>
                        <li>DIXCEL日本本社访问机会</li>
                        <li>Tokyo Auto Salon观展机会</li>
                        <li>Osaka Auto Messe观展机会</li>
                        <li>DIXCEL中国所有参与比赛VIP PASS</li>
                        <li>DIXCEL周边礼品</li>
                        <li>Team DIXCEL队服（外套/短袖）</li>
                        <li>赛道租车服务优惠</li>
                    </ui>
                </div>


                <div style="margin-bottom:20px;font-size: 12px;color: rgb(136, 136, 136)">✳特典内容可能根据实际情况进行调整</div>
                <div style="font-size: 16px;color: rgb(136, 136, 136);font-weight: bold">车队所属公司介绍</div>
                <div style=";text-align: center">
                    <el-image  style="width:100%;margin-bottom:20px"
                               :src="require('@/assets/image/moment/newsActivitiesPage/2023_04_19/8.jpg')"
                               fit="fit">
                    </el-image>
                </div>
                <div style="text-indent:30px;font-size: 14px;">DIXCEL是研发、生产高性能刹车片、刹车碟、刹车油、刹车卡钳的日本厂商。“DIXCEL”为
                    “decelerate”与“excellently”的单词组合，意味“优越减速”。DIXCEL中国“迪库盛贸易（上海）有限公司”于2011年6月在上海成立。</div>


                <div style="text-indent:30px;font-size: 14px;">DIXCEL中国不仅将日本高性能刹车片、碟、油、卡钳等带入中国，更是迎合中国市场的需求，
                    在中国特有车型调查、产品开发、性能测试、客户服务等方面展示出了子公司的优越性。丰富的产品线、充足的库存、
                    专业的客服对应使得DIXCEL在中国迅速成为畅销品牌，深得广大经销商与终端车主的喜爱。</div>

                <div style="text-indent:30px;font-size: 14px;">不仅在民用市场，在赛车运动中DIXCEL也取得了巨大成就。CTCC中国房车锦标赛、吉利超吉联赛、大众尚酷R杯、
                 大众POLO杯、CHINAGT、CEC、Formula Master、亚洲F3、亚洲宝珀GT、日本SuperGT、日本SuperTaikyu、
                D1日本/中国等国内外赛事都能看到DIXCEL的身影。通过参与高级别赛事，了解客户需求、分析产品性能，从而更好地为广大车主服务。</div>

                <div style="text-indent:30px;font-size: 14px;">从2011年起，DIXCEL中国积极参与China Auto Salon（CAS）、GTSHOW、ALL IN TUNING等国内展会，
                    积极与各地经销商、终端车主进行沟通、了解客户诉求，因地制宜地制定营销策略，以满足不同区域不同客户的诉求。</div>

                <div style="text-indent:30px;font-size: 14px;margin-bottom:20px">DIXCEL中国也秉承了DIXCEL日本“让客户满意，让员工满意”的经营理念，
                    客户满意的同时也是对我们最大的肯定，促使我们向客户提供更为优质的服务。</div>


                <div style="font-weight: bold;color: rgb(136, 136, 136)">车队报名方式：</div>
                <div style="">
                    <el-image  style="width:100%;margin-bottom:20px"
                               :src="require('@/assets/image/moment/newsActivitiesPage/2023_04_19/9.jpg')"
                               fit="fit">
                    </el-image>
                </div>
                <div style="margin-bottom:20px;text-align: center">
                    <el-image  style="width:100%;margin-bottom:20px"
                               :src="require('@/assets/image/moment/newsActivitiesPage/2023_04_19/10.png')"
                               fit="fit">
                    </el-image>
                </div>

                <div style="font-size: 14px;">固话：021-64498413（周一至周五9:00-18:00）</div>
                <div style="font-size: 14px;">手机：15102103860（常先生）</div>
                <div style="font-size: 14px;">邮箱：info@dixcel.cn（邮件请注明：车手报名）</div>
                <div style="font-size: 14px;">其他最新信息请关注DIXCEL中国微信公众号、DIXCEL中国官网（www.dixcel.cn）、DIXCEL中国官方微博（@DIXCELCHINA）等官方平台。</div>

                <div style="margin-bottom:20px;text-align: center">
                    <el-image  style="width:100%;margin-bottom:20px"
                               :src="require('@/assets/image/moment/newsActivitiesPage/2023_04_19/11.jpg')"
                               fit="fit">
                    </el-image>
                </div>

                <div style="margin-bottom:20px">
                    <a target="_blank" href="http://mp.weixin.qq.com/s?__biz=MzU1MjAyNzYyMw==&amp;mid=2247502074&amp;idx=2&amp;sn=57bc95e71564fad9efd6fa315764505f&amp;chksm=fb8adc72ccfd55645abd59d80ac214d3ba713eaa89ec5fdd62060328083b323e4ca65b7e7cbe&amp;scene=21#wechat_redirect" textvalue="吉利联赛PRO创始人车队车‍手席位开始招募" linktype="text" imgurl=""
                       style="text-decoration:none;font-size: 14px" imgdata="null" data-itemshowtype="0" tab="innerlink" data-linktype="2" hasload="1">吉利联赛PRO创始人车队车手席位开始招募</a>
                </div>
                <div style="margin-bottom:20px">

                    <a target="_blank" href="http://mp.weixin.qq.com/s?__biz=MzU1MjAyNzYyMw==&amp;mid=2247502013&amp;idx=1&amp;sn=ed3af240dd6d5c3e39830e6e75627904&amp;chksm=fb8adc35ccfd55234359105320f024fdeceefd18f2ed5410e7c32ebe8cc11e86f25b4530db0e&amp;scene=21#wechat_redirect" textvalue="PRO｜关于PRO你想了解的 FAQ奉上" linktype="text" imgurl=""
                      style="text-decoration:none;font-size: 14px" imgdata="null" data-itemshowtype="0" tab="innerlink" data-linktype="2" hasload="1">PRO｜关于PRO你想了解的 FAQ奉上</a>
                </div>

                <div style="margin-bottom:20px">
                    <el-image  style="width:100%;margin-bottom:20px"
                               :src="require('@/assets/image/moment/newsActivitiesPage/2023_04_19/12.jpg')"
                               fit="fit">
                    </el-image>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    export default {
        data() {
            return{

            }
        }
    }
</script>

<style lang="stylus" scoped>



    .container
        background-color : #000
        .box_one
            width: 100%;

        .box_bottom
            width: 100%;
            background-color #000


    .main {
        margin-bottom: 5px;
        width: 1003px;
        background-color: #fff;
        margin: 0 auto;
        position: relative;
        box-sizing: border-box;
        padding: 62px 50px 52px;
    }
    .title {
        color :#ab191d;
        text-align:center;
        margin-bottom 10px
    }

</style>
